import { ConfigProvider } from "antd";
import thTH from "antd/locale/th_TH";
import moment from "moment";
import "moment/locale/th";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import "./index.css";
import { AuthProvider } from "./lib/context/AuthProvider";
import { ActionProvider } from "./lib/context/actionProvider";

moment.locale("th");

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <ConfigProvider
        locale={thTH}
        theme={{
          token: {
            fontFamily: "Noto Sans Thai",
            fontSize: 15,
            thPrimary: "#6442A4",
            thSecondary: "#B6B6B6",
            thGrey: "#667085",
          },
          components: {
            Input: {
              colorBgContainer: "#F4F6FC",
              colorBorder: "#F4F6FC",
              border: "#F4F6FC",
              colorIcon: "#c3c9d2",
            },
            InputNumber: {
              colorBgContainer: "#F4F6FC",
              colorBorder: "#F4F6FC",
              border: "#F4F6FC",
              colorIcon: "#c3c9d2",
            },
            Button: {
              colorPrimary: "#6442A4",
              colorPrimaryHover: "#6442A4",
            },
            Select: {
              colorBgContainer: "#F4F6FC",
              colorBorder: "#F4F6FC",
            },
            DatePicker: {
              colorBgContainer: "#F4F6FC",
              colorBorder: "#F4F6FC",
            },
          },
        }}
      >
        <ActionProvider>
          <Routes>
            <Route path="/*" element={<App />} />
          </Routes>
        </ActionProvider>
      </ConfigProvider>
    </AuthProvider>
  </BrowserRouter>
);
